<script setup lang="ts"></script>

<template>
  <div :class="$style.container">
    <div :class="$style.animation"></div>
  </div>
</template>

<style module lang="scss">
.container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #efefef;
}

.animation {
  position: absolute;
  left: -45%;
  z-index: 45;
  width: 45%;
  height: 100%;
  background-image: linear-gradient(
    to left,
    rgb(251 251 251 / 0.05),
    rgb(251 251 251 / 0.3),
    rgb(251 251 251 / 0.6),
    rgb(251 251 251 / 0.3),
    rgb(251 251 251 / 0.05)
  );
  animation: loading 1s infinite;
}

@keyframes loading {
  0% {
    left: -45%;
  }

  100% {
    left: 100%;
  }
}
</style>
